export function getExtensionsElements<T>(entity: any, extension: string): T[] {
  return entity?.extensions?.[extension]?.elements || []
}
